import {Field2} from "@mytour/ui/form";
import {SplitterButtons} from "@mytour/ui/layout";
import type React from "react";
import {useForm} from "react-hook-form";
import {Button, Label} from "reactstrap";
import z from "zod";

const metadataUpdateSchema = z.object({
  reportId: z.string(),
  metadata: z.string().nullable(),
});

const formSchema = z.object({
  values: z.array(metadataUpdateSchema),
});

export type SuggestionsForm = z.infer<typeof formSchema>;

type Props = {
  onSubmit: (data: SuggestionsForm) => void;
  onClose: () => void;
  defaultValues: {
    metadata: string | null;
    reportId: string;
  }[];
};

export function MetadataForm({onSubmit, onClose, defaultValues}: Props) {
  const form = useForm<SuggestionsForm>({
    defaultValues: {values: defaultValues},
  });
  const values = form.watch("values");
  const valuesToDisplay = values.filter(({metadata}) => metadata !== null);

  return (
    <form onSubmit={handleSubmit}>
      <div style={{display: "flex", flexDirection: "column", maxHeight: "80vh"}}>
        <div style={{display: "flex", flexDirection: "column", overflowY: "auto"}}>
          {valuesToDisplay.length === 0 && (
            <div style={{textAlign: "center", marginTop: "20px"}}>
              <Label style={{fontStyle: "italic"}}>Aucune suggestion à afficher</Label>
            </div>
          )}
          {valuesToDisplay.map(({reportId}, index) => (
            <Field2
              key={reportId}
              name={`values.${index}.metadata`}
              label={
                <div style={{display: "flex", justifyContent: "space-between"}}>
                  <Label>{`Suggestion ${index + 1}`}</Label>
                  <Button color="danger" size="sm" onClick={() => handleDelete(index)}>
                    Supprimer
                  </Button>
                </div>
              }
              type="textarea"
              hookForm={form}
            />
          ))}
        </div>
        <SplitterButtons>
          <Button color="secondary" onClick={onClose} type="button">
            Fermer
          </Button>
          <Button color="primary" id="spectrum-utilisation">
            Enregistrer
          </Button>
        </SplitterButtons>
      </div>
    </form>
  );

  function handleDelete(index: number) {
    const newValues = [...values];
    newValues.splice(index, 1);
    form.setValue("values", newValues);
  }

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    e.stopPropagation();
    form.handleSubmit(onSubmit)(e);
  }
}
